import { ContactInformationActionTypes } from './contact-information-actions';
import { ContactInformationState, ContactInformationAction } from './contact-information';

export const initialState: ContactInformationState = {
  addressesList: [],
  addressListLoading: true,
  deletedAddressId: undefined,
  selectedAddress: undefined,
  selectedAddressId: undefined,
  selectedAddressLoc: { lat: '', lng: '' },
  addressIndex: undefined,
  newAddress: {
    address: undefined,
    latitude: undefined,
    longitude: undefined,
    plate: undefined,
    unit: undefined,
  },
  newAddressError: true,
  newAddressErrorMessage: 'آدرس و ثبت موقعیت مکانی الزامی است',
  deletedAddress: undefined,
  editAddressId: undefined,
  editAddressText: undefined,
  editAddressPlate: undefined,
  editAddressUnit: undefined,
  editAddressLocation: undefined,
  editAddressLoading: false,
  cityId: undefined,
  currentPage: 1,
  limit: 15,
  lastPage: 0,
  total: 0,
};

function contactInformationReducer(state = initialState, action: ContactInformationAction): ContactInformationState {
  switch (action.type) {
    case ContactInformationActionTypes.GET_ADDRESS_LIST:
      return {
        ...state,
        addressListLoading: true,
        cityId: action.data?.cityId,
        addressesList: initialState.addressesList,
        currentPage: initialState.currentPage,
      };

    case ContactInformationActionTypes.SET_ADDRESS_LIST:
      const newAddresses = action.data?.addressesList?.data || [];
      const firstAddress = newAddresses[0];
      return {
        ...state,
        addressesList: [...state.addressesList, ...newAddresses],
        selectedAddress: firstAddress?.address,
        selectedAddressId: firstAddress?.route_key,
        selectedAddressLoc: {
          lat: firstAddress?.latitude || '',
          lng: firstAddress?.longitude || '',
        },
        addressIndex: 1,
        addressListLoading: false,
        limit: action.data?.addressesList?.per_page || state.limit,
        currentPage: state.currentPage + 1,
        lastPage: action.data?.addressesList?.last_page || state.lastPage,
        total: action.data?.addressesList?.total || state.total,
      };

    case ContactInformationActionTypes.SET_DATA_LOADING:
      return {
        ...state,
        addressListLoading: action.data?.dataLoading || false,
      };

    case ContactInformationActionTypes.SET_DELETE_ADDRESS:
      return {
        ...state,
        deletedAddressId: action.data?.deletedAddressId,
        addressListLoading: true,
      };

    case ContactInformationActionTypes.SET_SELECTED_ADDRESS:
      return {
        ...state,
        selectedAddress: action.data?.selectedAddress,
        addressIndex: action.data?.addressIndex,
        selectedAddressId: action.data?.selectedAddressId,
        selectedAddressLoc: {
          lat: action.data?.latitude || '',
          lng: action.data?.longitude || '',
        },
      };

    case ContactInformationActionTypes.SET_NEW_ADDRESS:
      return {
        ...state,
        newAddress: action.data?.newAddress || state.newAddress,
        addressListLoading: true,
        newAddressError: !action.data?.newAddress?.address || !action.data?.newAddress?.latitude || !action.data?.newAddress?.longitude,
      };

    case ContactInformationActionTypes.SET_ADDRESS_TEXT:
      return {
        ...state,
        newAddress: {
          ...state.newAddress,
          address: action.data?.address,
        },
        newAddressError: !action.data?.address || !state.newAddress.latitude || !state.newAddress.longitude,
      };

    case ContactInformationActionTypes.SET_ADDRESS_UNIT:
      return {
        ...state,
        newAddress: {
          ...state.newAddress,
          unit: action.data?.unit,
        },
        newAddressError: !state.newAddress.address || !state.newAddress.latitude || !state.newAddress.longitude,
      };

    case ContactInformationActionTypes.SET_ADDRESS_PLATE:
      return {
        ...state,
        newAddress: {
          ...state.newAddress,
          plate: action.data?.plate,
        },
        newAddressError: !state.newAddress.address || !state.newAddress.latitude || !state.newAddress.longitude,
      };

    case ContactInformationActionTypes.CLEAR_NEW_ADDRESS:
      return {
        ...state,
        newAddress: initialState.newAddress,
      };

    case ContactInformationActionTypes.SET_ADDRESS_LOCATION:
      return {
        ...state,
        newAddress: {
          ...state.newAddress,
          longitude: action.data?.addressLocation?.lng,
          latitude: action.data?.addressLocation?.lat,
        },
        newAddressError: !state.newAddress.address || !action.data?.addressLocation?.lat || !action.data?.addressLocation?.lng,
      };

    case ContactInformationActionTypes.SET_NEW_ADDRESS_ID:
      return {
        ...state,
        selectedAddressId: action.data?.selectedAddressId,
        selectedAddressLoc: {
          lat: action.data?.latitude || '',
          lng: action.data?.longitude || '',
        },
      };

    case ContactInformationActionTypes.RESET_ADDRESS_ITEMS:
      return {
        ...state,
        addressesList: initialState.addressesList,
      };

    case ContactInformationActionTypes.GET_EDIT_ADDRESS:
      return {
        ...state,
        editAddressId: action.data?.editAddressId || state.editAddressId,
        editAddressText: action.data?.editAddressText,
        editAddressPlate: action.data?.editAddressPlate,
        editAddressUnit: action.data?.editAddressUnit,
        editAddressLocation: action.data?.editAddressLocation || state.editAddressLocation,
      };

    case ContactInformationActionTypes.SET_EDIT_ADDRESS_TEXT:
      return {
        ...state,
        editAddressText: action.data?.editAddressText,
      };

    case ContactInformationActionTypes.SET_EDIT_ADDRESS_PLATE:
      return {
        ...state,
        editAddressPlate: action.data?.editAddressPlate,
      };

    case ContactInformationActionTypes.SET_EDIT_ADDRESS_UNIT:
      return {
        ...state,
        editAddressUnit: action.data?.editAddressUnit,
      };

    case ContactInformationActionTypes.SET_EDIT_ADDRESS_LOCATION:
      return {
        ...state,
        editAddressLocation: action.data?.editAddressLocation,
      };

    case ContactInformationActionTypes.SET_EDIT_ADDRESS:
      return {
        ...state,
        editAddressLoading: true,
      };

    case ContactInformationActionTypes.SET_EDIT_ADDRESS_INITIAL:
      return {
        ...state,
        editAddressLocation: initialState.editAddressLocation,
        editAddressId: initialState.editAddressId,
        editAddressText: initialState.editAddressText,
        editAddressLoading: false,
      };

    default:
      return state;
  }
}

export default contactInformationReducer;
